import { Routes, RouterModule } from '@angular/router';
import { AuthguardService } from '../authguard.service';
import { ModuleWithProviders } from '@angular/core';
import {LinksComponent} from './links.component';
import {ListLinksComponent} from './list-links/list-links.component';
import {EditLinkComponent} from './edit-link/edit-link.component';

export const linksRoutes: Routes = [
    {
        path: 'links',
        component: LinksComponent,
        canActivate: [AuthguardService], // comment out for testing during development
        children: [
            {path: '',
                redirectTo: 'list',
                pathMatch: 'full'},
            {path: 'new',
                component: EditLinkComponent},
            {path: 'list',
                component: ListLinksComponent},
            {path: 'edit/:id',
                component: EditLinkComponent}
        ]
    }
];



// WEBPACK FOOTER //
// ./src/app/links/links.routes.ts